import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {DeputyDto} from "../../../../modules/workflow/dto/DeputyDto";
import {DeputyApi} from "../../../../modules/workflow/api/DeputyApi";
import {FormattedMessage, useIntl} from "react-intl";
import DeputyDetailDialog from "./components/DeputyDetailDialog";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {Card, CardHeader, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import ModifyIconButton from "../../../../components/buttons/ModifyIconButton";
import DeleteIconButton from "../../../../components/buttons/DeleteIconButton";
import AddIconButton from "../../../../components/buttons/AddIconButton";
import RefreshIconButton from "../../../../components/buttons/RefreshIconButton";
import {useConfirm} from "material-ui-confirm";
import {UserApi} from "../../../../modules/account/api/UserApi";
import {UserDto} from "../../../../modules/account/dto/UserDto";
import StringUtils from "../../../../utils/StringUtils";

const Index: React.FC = () => {

    const intl = useIntl();

    const confirm = useConfirm();

    const [deputyList, setDeputyList] = useState<Array<DeputyDto>>([]);

    const [openDetailModal, setOpenDetailModal] = useState(false);

    const [currentRow, setCurrentRow] = useState<DeputyDto>(new DeputyDto());

    const [sessionUser, setSessionUser] = useState<UserDto>(new UserDto());

    useEffect(() => {
        // 查询用户组列表
        fetchDeputyList();
        fetchSessionUser();
    }, []);

    const fetchDeputyList = async () => {
        const responseResult = await DeputyApi.getMyDeputyList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setDeputyList(responseResult.data);
        }
    };

    const fetchSessionUser = async () => {
        const responseResult = await UserApi.getSessionUser();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setSessionUser(responseResult.data);
        }
    };

    const handleModify = async (record: DeputyDto) => {
        setCurrentRow(record);
        setOpenDetailModal(true);
    };

    const handleDelete = async (record: DeputyDto) => {
        confirm({title: intl.formatMessage({id: 'COMMON_DELETE_CONFIRM'})})
            .then(async () => {
                const responseResult = await DeputyApi.deleteDeputy(record.id);
                if (responseResult.status === HttpStatus.SUCCESS) {
                    MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
                    fetchDeputyList();
                }
            })
            .catch(() => {
                console.log('cancel');
            });
    };

    const handleAdd = () => {
        const deputy = new DeputyDto();
        deputy.executorUserId = sessionUser.id;
        deputy.executorName = sessionUser.fullName;
        deputy.executorMobile = sessionUser.mobile;
        deputy.executorEmail = sessionUser.email;
        setCurrentRow(deputy);
        setOpenDetailModal(true);
    };

    return (
        <div>
            <DeputyDetailDialog open={openDetailModal}
                                deputy={currentRow}
                                onOk={fetchDeputyList}
                                onClose={() => setOpenDetailModal(false)}/>
            <Card>
                <CardHeader title={intl.formatMessage({id: 'WORKFLOW_DEPUTY_LIST'})}
                            action={
                                <div>
                                    <AddIconButton onClick={handleAdd}/>
                                    <RefreshIconButton onClick={() => fetchDeputyList()}/>
                                </div>
                            }/>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{intl.formatMessage({id: 'WORKFLOW_DEPUTY_AGENT_NAME'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'WORKFLOW_DEPUTY_AGENT_EMAIL'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'WORKFLOW_DEPUTY_AGENT_MOBILE'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'WORKFLOW_DEPUTY_START_TIME'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'WORKFLOW_DEPUTY_END_TIME'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {deputyList.map((row, index) => (
                            <TableRow key={row.id}>
                                <TableCell>{row.agentName}</TableCell>
                                <TableCell>{row.agentEmail}</TableCell>
                                <TableCell>{row.agentMobile}</TableCell>
                                <TableCell>{StringUtils.formatDate(row.startTime)}</TableCell>
                                <TableCell>{StringUtils.formatDate(row.endTime)}</TableCell>
                                <TableCell>
                                    <ModifyIconButton onClick={() => handleModify(row)}/>
                                    <DeleteIconButton onClick={() => handleDelete(row)}/>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

            </Card>
        </div>
    );
};

export default Index;
